
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyDXmYT-PeggJhDokDftcTepvmyn8-Os0fc",
  authDomain: "roky-das.firebaseapp.com",
  databaseURL: "https://roky-das.firebaseio.com",
  projectId: "roky-das",
  storageBucket: "roky-das.appspot.com",
  messagingSenderId: "476083530966",
  appId: "1:476083530966:web:a54a49ca5b934e029dad77"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// initialize firestore
export const db = getFirestore(app)